window.addEventListener("load",function(){
  document.querySelectorAll('.tab-section').forEach(section => {
  const tabs = section.querySelectorAll('[data-tab-target]');
  const tabContents = section.querySelectorAll('[data-tab-content]');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = section.querySelector(tab.dataset.tabTarget);
      // Remove 'active' class from all tab contents and tabs in this section
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active');
      });
      tabs.forEach(tab => {
        tab.classList.remove('active');
      });
      // Add 'active' class to the clicked tab and its target content
      tab.classList.add('active');
      target.classList.add('active');
      // Find and update the closest tab container (or any other desired element)
      const closestTabContainer = tab.closest('.tab-section');
      if (closestTabContainer) {
        const allTabContainers = document.querySelectorAll('.tab-section');
        allTabContainers.forEach(container => {
          container.classList.remove('active');
        });
        closestTabContainer.classList.add('active');
      }
    });
  });
});
})